"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("jquery");
require("jszip");
require("datatables.net-dt");
require("datatables.net-buttons-dt");
require("datatables.net-buttons/js/buttons.colVis.js");
require("datatables.net-buttons/js/buttons.html5.js");
require("datatables.net-buttons/js/buttons.print.js");
require("datatables.net-responsive-dt");
require("datatables.net-select-dt");
var to_regex_range_1 = __importDefault(require("to-regex-range"));
var Help_1 = __importDefault(require("./Help"));
var ac_tables_help_1 = __importDefault(require("./ac.tables.help"));
var ac_tryGetResult_1 = __importDefault(require("./ac.tryGetResult"));
var RowDetailsController = /** @class */ (function () {
    function RowDetailsController() {
    }
    return RowDetailsController;
}());
var AcTables;
(function (AcTables) {
    var domIdUsed;
    var table;
    var searchObject;
    var searchControlIndexes = [];
    var rangeSearchObject = {};
    function clearRangeSearchObject() {
        rangeSearchObject = {};
    }
    function setRangeSearchValue(colIndex, type, val, propertyName) {
        var existingObject = prepareRangeObjectForIndex(colIndex, type);
        if (val === "") {
            val = null;
        }
        existingObject[propertyName] = val;
        var otherPropertyName = (propertyName === "to") ? "from" : "to";
        if (existingObject[propertyName] === null && existingObject[otherPropertyName] === null) {
            delete rangeSearchObject[colIndex];
        }
        else {
            rangeSearchObject[colIndex] = existingObject;
        }
    }
    AcTables.setRangeSearchValue = setRangeSearchValue;
    function prepareRangeObjectForIndex(colIndex, type) {
        var existingObject = rangeSearchObject[colIndex];
        if (Help_1.default.isNullOrUndef(existingObject)) {
            existingObject = { type: type, from: null, to: null };
        }
        return existingObject;
    }
    function setSearchObject() {
        searchObject = {};
        searchControlIndexes.forEach(function (i) {
            var valFromControl = $("#col_" + i + "_filter").val(); //  console.log(`i : ${i} valFromControl : ${valFromControl}`);
            if (!Help_1.default.isNullOrEmpty(valFromControl)) {
                searchObject[i] = valFromControl; //  console.log(`setting search object i : ${i} valFromControl : ${valFromControl}`);
            }
        });
    }
    function _Init_Table(domId, dtJson, rowDetailsController) {
        //$((document) as any).ready(function () { //removed ready for UV
        _Init_Table_Core(domId, dtJson, rowDetailsController);
        initCustomFilters();
        applyCustomFilters(); //console.log('done _Init_Table');
        return table;
        //});
    }
    ;
    function initCustomFilters() {
        $(".data_filter_control").on("change", function () { applyCustomFilters(); });
    }
    ;
    function applyCustomFilters() {
        //console.log(`applyCustomFilters`);
        setSearchObject();
        table.draw();
    }
    ;
    function removeColumnFilters() {
        clearRangeSearchObject();
        table.columns().search('').draw(); //table.search('').columns().search('').draw();//USE THIS to undo global / custom filters too 
    }
    ;
    function reApplyColumnFilters() {
        //console.log("reApplyColumnFilters");
        var colIndexesVisible = table.columns(':visible').flatten();
        var headFilterRow = $("#" + domIdUsed).find("> thead > tr").eq(1);
        colIndexesVisible.each(function (colIdx) {
            var divCellWrap = headFilterRow.find("#" + colIdx).children("div").first();
            var cellClass = divCellWrap.attr('class');
            if (Help_1.default.isString(cellClass)) {
                var colFilterType = ac_tables_help_1.default.getColFilterType(cellClass);
                if (colFilterType === ac_tables_help_1.default.ColSearchTypes.NoSearch) {
                    //Do nothing
                    //console.log("no search for this col");  
                }
                else if (colFilterType === ac_tables_help_1.default.ColSearchTypes.Text) {
                    var txtToSearch = $(divCellWrap).children("input").first().val(); //$(divCellWrap).children("input").first().change();
                    table.column(colIdx).search(txtToSearch);
                }
                else if (colFilterType === ac_tables_help_1.default.ColSearchTypes.DateRange) {
                    var newCalValFrom = $("input.from", divCellWrap).val();
                    var newCalValTo = $("input.to", divCellWrap).val();
                    setRangeSearchValue(colIdx, RangeTypes.Date, newCalValFrom, "from");
                    setRangeSearchValue(colIdx, RangeTypes.Date, newCalValTo, "to");
                    //var linkFrom = $("a.from", divCellWrap);
                    //var linkFromClear = $("a.from_clear", divCellWrap);
                    //var hiddenFrom = $("input.from", divCellWrap);
                    //const newCalValFrom = dateValChange(linkFrom, linkFromClear, hiddenFrom, colIdx, "from");
                    //setRangeSearchValue(colIdx, RangeTypes.Date, newCalValFrom, "from");
                    //var linkTo = $("a.to", divCellWrap);
                    //var linkToClear = $("a.to_clear", divCellWrap);
                    //var hiddenTo = $("input.to", divCellWrap);
                    //const newCalValTo = dateValChange(linkTo, linkToClear, hiddenTo, colIdx, "to");
                    //setRangeSearchValue(colIdx, RangeTypes.Date, newCalValTo, "to");
                    //applyCustomFilters();
                    //$(divCellWrap).children("input").change();//TODO:check works?
                }
                else if (colFilterType === ac_tables_help_1.default.ColSearchTypes.Bool) {
                    var hiddenInput = $(divCellWrap).find("input");
                    table.column(colIdx).search(hiddenInput.val()); //table.column(colIdx).search(hiddenInput.val()).draw();
                }
                else if (colFilterType === ac_tables_help_1.default.ColSearchTypes.NumericalRange) {
                    numericalRangeChange(divCellWrap, colIdx, true); //$(divCellWrap).children("input").first().change(); //TODO: this is lazy - refactor code 
                }
                else if (colFilterType === ac_tables_help_1.default.ColSearchTypes.MultiSelect) {
                    var rbName = "rb_" + colIdx;
                    chbsChange(divCellWrap, rbName, colIdx, true);
                }
            }
            else {
                var selectEl = $(divCellWrap).find("select"); //$(divCellWrap).find("select").change();
                selectChange(selectEl, colIdx, true);
            }
        });
        //console.log("table.draw() from reApplyColumnFilters");
        table.draw();
    }
    ;
    function _Init_Table_Core(domId, dtJson, rowDetailsController) {
        //var tableElemTest = $(`#${domId}`);
        //console.log(`_Init_Table_Core ${tableElemTest.length}`);
        //var orderSpec: any | undefined;
        //if (!Help.isNullOrUndef(dtJson.orderSpec)) {
        //    orderSpec = dtJson.orderSpec;
        //}
        //dtJson = JSON.parse(dtJson);
        //atempt to cleanup
        //$(`#${domId}`).off();
        //table = null;
        //if ($.fn.dataTable.isDataTable(`#${domId}`)) {
        //    console.log("EXISTING FOUND");
        //    table = $(`#${domId}`).DataTable();
        //    table.destroy();
        //}
        //table = null;
        //domIdUsed = null;
        //end
        domIdUsed = domId;
        _setup_Orthogonal_Render(dtJson);
        var exportOptions = {
            orthogonal: 'export',
            columns: ':visible',
            modifier: {
                selected: true
            }
        };
        var config = {
            destroy: true,
            deferRender: true,
            order: dtJson.orderSpec,
            lengthMenu: [[10, 20, 50, -1], [10, 20, 50, "All"]],
            pageLength: -1,
            pagingType: "simple_numbers_no_ellipses",
            language: {
                info: "_START_ to _END_ of _TOTAL_",
                infoFiltered: "(filtered from _MAX_)",
                lengthMenu: "Display _MENU_",
                search: "",
                searchPlaceholder: "Search...",
                emptyTable: "No records",
                processing: "DataTables is currently busy"
            },
            data: dtJson.data,
            dom: "liBfrtp",
            buttons: [
                {
                    extend: 'collection',
                    text: 'Export',
                    titleAttr: 'Export',
                    className: 'require-selected show-count-selected',
                    buttons: [
                        {
                            extend: 'print',
                            exportOptions: exportOptions
                        }, {
                            extend: 'copy',
                            exportOptions: exportOptions
                        }, {
                            extend: 'excel',
                            //title: '',//this will remove the first row title from excel export
                            exportOptions: exportOptions
                        }, {
                            extend: 'csv',
                            exportOptions: exportOptions
                        }, {
                            extend: 'pdf',
                            exportOptions: exportOptions
                        }
                    ]
                },
                {
                    extend: 'selectAll',
                    text: "Select",
                    action: function (e, dt, button, config) {
                        dt.rows({ page: 'current' })
                            .select(); //selects only from current page //TODO:TD could remove this to make it a true Select All. Could decide dynamically on basis of number of rows TOTAL...
                    }
                },
                //{
                //    extend: 'selectAll',
                //    text: "Select All",
                //    //action: function (e, dt, button, config) {
                //    //    dt.rows({ page: 'current' })
                //    //        .select(); //selects only from current page //TODO:TD could remove this to make it a true Select All. Could decide dynamically on basis of number of rows TOTAL...
                //    //}
                //},
                {
                    extend: 'selectNone',
                    text: "Deselect All"
                }, {
                    extend: 'colvis',
                    text: "Columns",
                    columns: ':not(.inv)'
                }
            ],
            select: true,
            columnDefs: dtJson.columnDefs,
        };
        //remove handlers for UV vue to avoid doubling up
        //$(`#${domId}`)
        //    .off('init.dt')
        //    .off("draw.dt page.dt order.dt draw.dt column-visibility.dt search init.dt deselect.dt select.dt")
        //    .off("column-visibility.dt init.dt");
        //usual stuff
        table = $("#" + domId).on('init.dt', function () {
            $('#loader').hide();
            $('#filters').animate({ opacity: 1 }, 600);
        })
            .on('draw.dt page.dt order.dt draw.dt column-visibility.dt search init.dt deselect.dt select.dt', ac_tables_help_1.default._updateOperationButtons)
            .on('column-visibility.dt init.dt', _updateColFilters) //this is the problem... hmmm
            .DataTable(config);
        //alert("setting tbody a click");
        $("#" + domId + " tbody").on('click', 'a', function (e) {
            //alert("tbody a click"); //this works for <a href=x
            e.stopPropagation(); //stop row selection on links https://datatables.net/forums/discussion/28608/tabletools-prevent-row-click-behaviour-should-not-select-row
        });
        if (rowDetailsController instanceof RowDetailsController) {
            //console.log("rowDetailsController setup");
            $("#" + domId + " tbody").on('click', '.inf', function (e) {
                e.stopPropagation();
                var tr = $(this).closest('tr');
                var row = table.row(tr);
                if (row.child.isShown()) { // This row is already open - close it
                    tr.removeClass('shown');
                    $('div.row_details', row.child()).slideUp(function () {
                        row.child.hide(); //hides it (doesn't remove it) 
                    });
                }
                else {
                    var cellData = table.cell(this.parentNode).data();
                    var rowId = cellData.p; //find the id for object concerned
                    if (rowDetailsController.childExists(rowId)) {
                        row.child.show(); //console.log("guessing will just show ok ??");
                        tr.addClass('shown');
                        $('div.row_details', row.child()).slideDown();
                    }
                    else {
                        rowDetailsController.createChild(rowId, row, tr, _setup_Orthogonal_Render);
                    }
                }
            });
        }
    }
    ;
    function _setup_Orthogonal_Render(dtJson) {
        dtJson.columnDefs.forEach(function (c) { return c["render"] = function (data, type, row, meta) { return ac_tables_help_1.default.advancedRender(data, type, row, meta, c); }; });
    }
    ;
    function dateValChange(calTriggerBtn, calClearBtn, hiddenEl, colIdx, comparison) {
        var newCalVal = hiddenEl.val();
        var calLinkTitle;
        if (!Help_1.default.isNullOrEmpty(newCalVal)) {
            calLinkTitle = " " + comparison + " " + newCalVal;
            calTriggerBtn.addClass("applied");
            calClearBtn.removeClass("disabled");
            calClearBtn.on("click", function () {
                hiddenEl.val("");
                hiddenEl.change(); //rinse repeat - for titles classes etc
            });
            calClearBtn.attr("title", "Clear date");
        }
        else {
            calLinkTitle = comparison + " any date";
            calTriggerBtn.removeClass("applied");
            calClearBtn.addClass("disabled");
            calClearBtn.off("click");
            calClearBtn.attr("title", "");
        }
        calTriggerBtn.attr("title", calLinkTitle);
        return newCalVal;
    }
    function _updateColFilters(e, settings) {
        var idOfTargetTable = e.currentTarget.id; //console.log("_updateColFilters >>>>");
        //console.log("_updateColFilters " + idOfTargetTable);
        //console.log($(`#${idOfTargetTable}`).length);  
        var dtApi = $("#" + idOfTargetTable).dataTable().api(); //new $.fn.dataTable.Api(settings); //var dtApi = new $.fn.dataTable.Api(settings);
        var header = $("#" + domIdUsed).find("> thead");
        var headFilterRow = header.find("> tr").eq(1);
        if (headFilterRow.length === 0) {
            headFilterRow = $("<tr class=\"row_filter\"></tr>");
            headFilterRow.appendTo(header);
        }
        var colIndexesVisible = dtApi.columns(':visible').flatten();
        //remove any filters that are for cols no longer visible 
        headFilterRow.children().each(function (index, el) {
            var filter = $(el);
            var colIndex = parseInt(filter.attr('id'));
            if (colIndexesVisible.indexOf(colIndex) === -1) {
                //console.log(`cannot find ${colIndex} in visible indexes.. .removing`);
                filter.remove();
            }
        });
        var colDefs = dtApi.settings().init().columnDefs;
        //Add any missing filters 
        var i = 0;
        colIndexesVisible.each(function (colIdx) {
            var cell = headFilterRow.find("#" + colIdx);
            if (cell.length === 0) {
                cell = $("<th id=\"" + colIdx + "\"></th>");
                headFilterRow.insertAt(cell, i);
                var colSearchType = ac_tables_help_1.default.getColFilterType(colDefs[colIdx].className); //find class / type of col and create diff controls accordingly 
                if (colSearchType === ac_tables_help_1.default.ColSearchTypes.NoSearch) {
                    //do nothing
                }
                else if (colSearchType === ac_tables_help_1.default.ColSearchTypes.Text) {
                    $('<input type="text" />').appendTo(cell)
                        .on('keyup change', function () {
                        table.column(colIdx).search($(this).val()).draw();
                    });
                    cell.wrapInner('<div class="search_text" />');
                }
                else if (colSearchType === ac_tables_help_1.default.ColSearchTypes.DateRange) {
                    //TODO:flesh calendar was in sps, not pulled across yet
                    //$('<input type="hidden" class="from" /><a class="from" title="from any date"><i class="fa fa-calendar"></i></a><a class="from_clear disabled" title="Clear date"><i class="fa fa-times"></i></a>' +
                    //    '<input type="hidden" class="to" /><a class="to" title="to any date"><i class="fa fa-calendar"></i></a><a class="to_clear disabled" title="Clear date"><i class="fa fa-times"></i></a>')
                    //    .appendTo(cell);
                    //cell.wrapInner('<div class="search_date_range" />');
                    //var linkFrom = $("a.from", cell);
                    //var linkFromClear = $("a.from_clear", cell);
                    //var hiddenFrom = $("input.from", cell);
                    //hiddenFrom.bind("change", function () {
                    //    const newCalVal = dateValChange(linkFrom, linkFromClear, hiddenFrom, colIdx, "from");
                    //    setRangeSearchValue(colIdx, RangeTypes.Date, newCalVal, "from");
                    //    applyCustomFilters();
                    //});
                    //Calendar.setupLink(linkFrom[0] as any, hiddenFrom[0] as any);
                    //var linkTo = $("a.to", cell);
                    //var linkToClear = $("a.to_clear", cell);
                    //var hiddenTo = $("input.to", cell);
                    //hiddenTo.bind("change", function () {
                    //    const newCalVal = dateValChange(linkTo, linkToClear, hiddenTo, colIdx, "to");
                    //    setRangeSearchValue(colIdx, RangeTypes.Date, newCalVal, "to");
                    //    applyCustomFilters();
                    //});
                    //Calendar.setupLink(linkTo[0] as any, hiddenTo[0] as any);
                }
                else if (colSearchType === ac_tables_help_1.default.ColSearchTypes.Bool) {
                    $('<a><span>All</span><input type="hidden" value=""></a>')
                        .appendTo(cell).on('click', function () {
                        var hiddenInput = $(this).find("input"); //console.log(`hiddenInput ${hiddenInput.val()}`);
                        var currentVal = hiddenInput.val();
                        var valToSet;
                        var displayToSet;
                        if (Help_1.default.isNullOrEmpty(currentVal)) { //ALL,X,Tick
                            valToSet = "false";
                            displayToSet = '<i class="fa fa-times"></i>';
                        }
                        else if (currentVal === "false") {
                            valToSet = "true";
                            displayToSet = '<i class="fa fa-check"></i>';
                        }
                        else { //if (currentVal === "true") {
                            valToSet = "";
                            displayToSet = 'All';
                        }
                        hiddenInput.val(valToSet);
                        $(this).find("span").html(displayToSet);
                        table.column(colIdx).search(valToSet).draw();
                    });
                    cell.wrapInner('<div class="search_bool" />');
                }
                else if (colSearchType === ac_tables_help_1.default.ColSearchTypes.NumericalRange) {
                    $('<input type="text" class="from" /> - <input type="text" class="to" />').appendTo(cell);
                    $('.from,.to', cell).on('keyup change', function () {
                        numericalRangeChange(cell, colIdx, false);
                    });
                    cell.wrapInner('<div class="search_num_range" />');
                }
                else if (colSearchType === ac_tables_help_1.default.ColSearchTypes.MultiSelect) {
                    var divChbs = $('<div class="search_multi_select" />').appendTo(cell);
                    $('<a class="act_as_button" title="Combine options with logical operator AND"><span><i class="fa fa-plus"></i></span><input type="hidden" value="true"></a>')
                        .appendTo(divChbs).on('click', function () {
                        var hiddenInput = $(this).find("input:hidden");
                        var currentVal = hiddenInput.val();
                        var valToSet, displayToSet, btnTitle;
                        if (currentVal === "true") {
                            valToSet = "false";
                            displayToSet = '<i class="fa fa-filter"></i>';
                            btnTitle = "Combine options with logical operator OR";
                        }
                        else if (currentVal === "false") {
                            valToSet = "true";
                            displayToSet = '<i class="fa fa-plus"></i>';
                            btnTitle = "Combine options with logical operator AND";
                        }
                        hiddenInput.val(valToSet);
                        $(this).find("span").html(displayToSet);
                        $(this).attr("title", btnTitle);
                        chbsChange(divChbs, rbName, colIdx, false);
                    });
                    var valsToRender = [];
                    dtApi.column(colIdx).cache('search').sort().unique().each(function (searchVal) {
                        if (!Help_1.default.isNullOrEmpty(searchVal)) {
                            var split = searchVal.split(',');
                            for (var i = 0; i < split.length; i++) {
                                var v = split[i];
                                valsToRender.push(v.trim());
                            }
                        }
                    });
                    var valsToRenderUnique = valsToRender.filter(function (x, i, a) { return a.indexOf(x) === i; }); //get unique entries only 
                    // console.log(valsToRenderUnique);
                    var rbName = "rb_" + colIdx;
                    for (var x = 0; x < valsToRenderUnique.length; x++) {
                        var v = valsToRenderUnique[x];
                        divChbs.append($("<label><input type=\"checkbox\" name=\"" + rbName + "\" value=\"" + v + "\" />" + v + "</label>"));
                    }
                    divChbs.on('change', "input[type=checkbox]", function () {
                        chbsChange(divChbs, rbName, colIdx, false);
                    });
                }
                else {
                    var select = $('<select><option value="*">All</option></select>').appendTo(cell)
                        .on('change', function () {
                        selectChange($(this), colIdx, false);
                    });
                    cell.wrapInner('<div />');
                    dtApi.column(colIdx).cache('search').sort().unique().each(function (searchVal) {
                        if (Help_1.default.isNullOrEmpty(searchVal)) {
                            select.append($("<option value>--None--</option>"));
                        }
                        else {
                            select.append($("<option value=\"" + searchVal + "\">" + searchVal + "</option>"));
                        }
                    });
                }
            }
            i++;
        });
    }
    ;
    function chbsChange(divChbs, rbName, colIdx, inhibitDraw) {
        var hiddenInput = divChbs.find("input:hidden");
        var logicalAnd = (hiddenInput.val() === 'true');
        var valsString = '';
        if (logicalAnd) { //logical AND
            valsString = $("input:checkbox[name=\"" + rbName + "\"]:checked", divChbs).map(function () {
                var vStr = $(this).val();
                return "(?=.*" + vStr + ")"; //regex lookahead groups as per Alan Moore here https://stackoverflow.com/a/470602/661584
            }).get().join('');
        }
        else //logical OR
         {
            valsString = $("input:checkbox[name=\"" + rbName + "\"]:checked", divChbs).map(function () {
                return $(this).val();
                ;
            }).get().join('|'); //works with datatables.net convention of | as OR
        }
        if (inhibitDraw) {
            table.column(colIdx).search(valsString, true, false, false);
        }
        else {
            table.column(colIdx).search(valsString, true, false).draw();
        }
    }
    function selectChange(selectEl, colIdx, inhibitDraw) {
        var valToMatch = selectEl.val(); //var valToMatch = $(this).val() as string;
        if (Help_1.default.isNullOrEmpty(valToMatch)) {
            if (inhibitDraw) {
                table.column(colIdx).search('^\s*$', true, false);
            }
            else {
                table.column(colIdx).search('^\s*$', true, false).draw();
            }
        }
        else if (valToMatch === "*") {
            if (inhibitDraw) {
                table.column(colIdx).search('');
            }
            else {
                table.column(colIdx).search('').draw();
            }
        }
        else {
            if (inhibitDraw) {
                table.column(colIdx).search("^" + valToMatch + "$", true, false, true); //use regex to ensure exact match only 
            }
            else {
                table.column(colIdx).search("^" + valToMatch + "$", true, false, true).draw(); //use regex to ensure exact match only 
            }
        }
    }
    function numericalRangeChange(cellWrap, colIdx, inhibitDraw) {
        var minDefault = 0;
        var maxDefault = 10000000;
        var minNum = minDefault;
        var maxNum = maxDefault;
        var valFrom = String($('.from', cellWrap).val());
        var valTo = String($('.to', cellWrap).val());
        var minVal = new ac_tryGetResult_1.default();
        if (Help_1.default.numberTryParse(valFrom, minVal)) {
            minNum = minVal.value;
        }
        var maxVal = new ac_tryGetResult_1.default();
        if (Help_1.default.numberTryParse(valTo, maxVal)) {
            maxNum = maxVal.value;
        }
        if (minNum !== minDefault || maxNum !== maxDefault) {
            var t = to_regex_range_1.default(minNum, maxNum);
            var searchRegex = "^" + t + "$";
            if (inhibitDraw) {
                table.column(colIdx).search(searchRegex, true, false);
            }
            else {
                table.column(colIdx).search(searchRegex, true, false).draw(); //console.log(`applying regex from minNum, maxNum = ${minNum}, ${maxNum}`);
            }
        }
        else {
            if (inhibitDraw) {
                table.column(colIdx).search(''); //console.log(`both min and max are defaulted -- should we clear the search?`);
            }
            else {
                table.column(colIdx).search('').draw();
            }
        }
    }
    function _toggleFilters() {
        var headFilterRow = $("#" + domIdUsed).find("> thead > tr").eq(1);
        headFilterRow.toggleClass('active');
        var respVal = headFilterRow.hasClass('active');
        if (!respVal) {
            removeColumnFilters();
        }
        else {
            reApplyColumnFilters();
        }
        return respVal;
    }
    function _setColVis(colIndex, visible) {
        table.column(colIndex).visible(visible);
    }
    ;
    /**
     * Inits JSON based table
    */
    function initTable(domId, dtJson, rowDetailsController) {
        return _Init_Table(domId, dtJson, rowDetailsController);
    }
    AcTables.initTable = initTable;
    function setColVis(colIndex, visible) {
        return _setColVis(colIndex, visible);
    }
    AcTables.setColVis = setColVis;
    /**
     * registers the index passed as one which needs checking when filtering "searching" happens
     */
    function registerForSearch(index) {
        searchControlIndexes.push(index);
    }
    AcTables.registerForSearch = registerForSearch;
    /**
     * get the list of values
     */
    function getSearchObject() {
        return searchObject;
    }
    AcTables.getSearchObject = getSearchObject;
    /**
    * get the list of objects describing range filters
    */
    function getRangeSearchObject() {
        return rangeSearchObject;
    }
    AcTables.getRangeSearchObject = getRangeSearchObject;
    function getPrivateFilterData(data) {
        return ac_tables_help_1.default.advancedRender(data, 'private', null);
    }
    AcTables.getPrivateFilterData = getPrivateFilterData;
    //export function setRangeSearchValueFrom(colIndex: number, type: RangeTypes, valFrom: any) {
    //}
    //function setRangeSearchValueTo(colIndex: number, type: RangeTypes, valTo: any) {
    function toggleFilters() {
        return _toggleFilters();
    }
    AcTables.toggleFilters = toggleFilters;
    var RangeTypes;
    (function (RangeTypes) {
        RangeTypes[RangeTypes["Date"] = 0] = "Date";
    })(RangeTypes = AcTables.RangeTypes || (AcTables.RangeTypes = {}));
})(AcTables || (AcTables = {}));
exports.default = AcTables;
//# sourceMappingURL=ac.tables.js.map